//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import HelpCenterService from '../js/help_center_service';
export default {
  props: {
    video_id: {
      type: String
    }
  },
  data: function data() {
    return {
      actualVideo: {}
    };
  },
  created: function created() {
    console.log(this.$route.params);
    this.getVideobyID(this.$route.params.video_id);
  },
  methods: {
    traductor: function traductor(key) {
      return this.$i18n.t(key);
    },
    getVideobyID: function getVideobyID(id) {
      var _this = this;
      var idvideo = {
        "video_id": id
      };
      HelpCenterService.getVideobyID(idvideo).then(function (response) {
        if (response.success === true) _this.actualVideo = response.data;
        console.log("vid:", _this.actualVideo);
      }, function (err) {
        _this.$toast.warning("Error");
      });
    }
  },
  computed: {
    breadcrumbs: function breadcrumbs() {
      return [{
        text: this.traductor('help_center.help_center'),
        disabled: false,
        href: '/#/help_center/MainPage'
      }, {
        text: "Ver video",
        disabled: true
      }];
    }
  }
};